/* eslint-disable global-require */
import { ISET } from '@/types/app.d';

export default {};

// 登录view配置
export const LOGIN_SET: ISET = {
  title: '魔扣智星资源配置系统',
  desc: '机构管理及日常工作处理的好帮手',
  cover: require('./mc.png'),
  userPlaceholder: '请输入管理员账号',
  passPlaceholder: '请输入登录密码',
  showQrCode: true,
  userRules: {
    user: [{
      regex: /^[s]{0,}$/,
      errMsg: '请填写您的账号~',
    }],
    pass: [{
      regex: /^[s]{0,}$/,
      errMsg: '请填写您的密码~',
    }],
  },
};
